import React from 'react';
import { Link } from 'react-router-dom';
import VisualizerBackground from '../components/VisualizerBackground';
import YoutubeEmbed from '../components/YoutubeEmbed';
import ScrollAnimation from '../components/ScrollAnimation';
import videoData from '../data/videos.json';

const Videos = () => {
  const videos = videoData.all;
  const [activeCategory, setActiveCategory] = React.useState('all');
  
  const filteredVideos = activeCategory === 'all' 
    ? videos 
    : videos.filter(video => video.category === activeCategory);

  return (
    <div className="min-h-screen bg-drummer-dark text-white">
      <VisualizerBackground />
      
      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-client-yellow via-client-yellow to-client-teal animate-gradient-x">Video Gallery</span>
            </h1>
            <p className="text-xl text-white">
              Explore Daryian's performances, tutorials, vlogs, and more.
            </p>
          </div>
        </div>
      </section>
      
      {/* Filter Categories */}
      <section className="pb-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-2 md:gap-4">
            <button 
              className={`px-4 py-2 rounded-full transition-colors ${
                activeCategory === 'all' 
                  ? 'bg-client-yellow text-client-black' 
                  : 'bg-client-black/30 text-white hover:bg-client-black/50'
              }`}
              onClick={() => setActiveCategory('all')}
            >
              All Videos
            </button>
            <button 
              className={`px-4 py-2 rounded-full transition-colors ${
                activeCategory === 'performances' 
                  ? 'bg-client-yellow text-client-black' 
                  : 'bg-client-black/30 text-white hover:bg-client-black/50'
              }`}
              onClick={() => setActiveCategory('performances')}
            >
              Performances
            </button>
            <button 
              className={`px-4 py-2 rounded-full transition-colors ${
                activeCategory === 'studio' 
                  ? 'bg-client-yellow text-client-black' 
                  : 'bg-client-black/30 text-white hover:bg-client-black/50'
              }`}
              onClick={() => setActiveCategory('studio')}
            >
              Studio
            </button>
            <button 
              className={`px-4 py-2 rounded-full transition-colors ${
                activeCategory === 'vlogs' 
                  ? 'bg-client-yellow text-client-black' 
                  : 'bg-client-black/30 text-white hover:bg-client-black/50'
              }`}
              onClick={() => setActiveCategory('vlogs')}
            >
              Vlogs
            </button>
            <button 
              className={`px-4 py-2 rounded-full transition-colors ${
                activeCategory === 'tutorials' 
                  ? 'bg-client-yellow text-client-black' 
                  : 'bg-client-black/30 text-white hover:bg-client-black/50'
              }`}
              onClick={() => setActiveCategory('tutorials')}
            >
              Tutorials
            </button>
            <button 
              className={`px-4 py-2 rounded-full transition-colors ${
                activeCategory === 'drum-review' 
                  ? 'bg-client-yellow text-client-black' 
                  : 'bg-client-black/30 text-white hover:bg-client-black/50'
              }`}
              onClick={() => setActiveCategory('drum-review')}
            >
              Drum Reviews
            </button>
          </div>
        </div>
      </section>
      
      {/* Videos Grid */}
      <section className="py-8 md:py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredVideos.map((video, index) => (
              <div key={index} className="flex flex-col">
                <YoutubeEmbed videoId={video.id} title={video.title} />
                <h3 className="text-xl font-bold mt-4 mb-1">{video.title}</h3>
                <p className="text-white text-sm capitalize">{video.category}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Subscribe CTA */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="glassmorphic p-8 md:p-12 text-center">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Subscribe for New Videos
              </h2>
              <p className="text-xl text-white mb-8">
                Don't miss out on Daryian's latest performances, tutorials, and vlogs.
                Check out all the videos on his YouTube channel.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a 
                  href="https://youtube.com/@DaryianKelton" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="drum-button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                  Subscribe on YouTube
                </a>
                <Link to="/contact?topic=collaboration" className="drum-button-outline">
                  Contact for Collaboration
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Videos;
